export default "<p>Logout...</p>";